export default __webpack_public_path__ + "static/media/mysql.c3f3658c.png";